import React, { useEffect } from "react";
import { connect } from "react-redux";
import Input from "../componentes/Input.jsx";
import ButtonLogin from "../componentes/ButtonLogin.jsx";
import Api from "../../utils/Api.jsx";
import "./estilo_recuperarSenha.css";

function RecuperarSenha() {
  const [email, setEmail] = React.useState("");
  const [retornaEmail, setRetornaEmail] = React.useState(false);
  const [msgSucesso, setMsgSucesso] = React.useState(false);
  const [msgErro, setMsgErro] = React.useState(false);
  const [msgEmailInvalido, setMsgEmailInvalido] = React.useState(false);

  async function validaEmail() {
    if (email.includes("@")) {
      const emailFormatado = email.replace(/[/,',",`,´]/g, "");
      const ret = await Api.buscar("valida_email", "", emailFormatado);
      if (ret.dados[0]) {
        setRetornaEmail(true);
      } else {
        setMsgErro(true);
      }
      return ret;
    } else {
      setMsgEmailInvalido(true);
    }
  }

  async function enviaEmail() {
    const ret = await Api.buscar("envia_email", "", email);
    return ret;
  }

  function limpaCampos() {
    setMsgErro(false);
    setMsgEmailInvalido(false);
    setEmail("");
  }

  useEffect(() => {}, []);

  useEffect(() => {
    if (email) {
      setMsgSucesso(true);
      enviaEmail();
      setTimeout(() => {
        window.location.reload();
      }, 60000);
    }
  }, [retornaEmail]);

  return (
    <div>
      <div className="blocoLogin">
        <div className="apiceStart">
          <div className="apiceStart-icon">
            <i className={"fa rxzz " + global.app.icone} />
          </div>
          <div className="apiceStart-titulo">
            <b>ERP-BI</b>
          </div>
        </div>
        <div className="loginBox">
          <h2 className="loginBoxMsg">Recuperar senha</h2>
          <form>
            <div className="blocoInput">
              <Input
                className="inputEmail"
                placeholder="Digite seu email"
                uppercase={false}
                // type="email"
                disabled={msgSucesso}
                onFocus={() => limpaCampos()}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="blocoBotao">
              {!msgSucesso ? (
                <ButtonLogin
                  className="botaoEnviar"
                  onClick={() => validaEmail()}
                  label="Recuperar"
                />
              ) : (
                <ButtonLogin
                  className="botaoEnviar2"
                  label="Recuperar"
                  disabled
                />
              )}
            </div>
            <div className="divisao" />
            {msgSucesso && (
              <div className="blocoMsgSucesso">
                <div className="msgSucesso">
                  <b>Email enviado com sucesso!</b>
                  <br />
                </div>

                <div className="msgSucesso2">
                  Confira sua caixa de entrada e/ou sua caixa de spam.
                </div>
              </div>
            )}
            {msgErro && (
              <div className="blocoMsgErro">
                <div className="msgErro">
                  <b>Email não encontrado!</b>
                  <br />
                </div>

                <div className="msgErro2">
                  Confira o email preenchido e tente novamente.
                </div>
              </div>
            )}
            {msgEmailInvalido && (
              <div className="blocoMsgErro">
                <div className="msgErro">
                  <b>Email inválido!</b>
                  <br />
                </div>

                <div className="msgErro2">
                  Preencha os campos corretamente e tente novamente.
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default connect((state) => ({ usuario: state.usuario }))(RecuperarSenha);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/RecuperarSenha.jsx